'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _themes = require('../themes'),
    componentTheme = function componentTheme(baseTheme) {
  var _baseTheme$vstui = baseTheme.vstui,
      color = _baseTheme$vstui.color,
      size = _baseTheme$vstui.size,
      ninja11 = color.ninja.getShade(11),
      backgroundColor_naked = color.transparent,
      borderColor_naked = color.transparent,
      color_disabled = color.black;
  return (0, _themes.createComponentTheme)(baseTheme, {
    SearchFormInputControl_borderColor_focus: ninja11,
    SearchFormInputControl_boxShadow_focus: '0 0 0 1px ' + ninja11,
    InputControl_backgroundPosition_small: 'right 40px top ' + (size.small - 2 - 14) / 2 + 'px',
    InputControl_backgroundPosition_medium: 'right 40px top ' + (size.medium - 2 - 14) / 2 + 'px',
    InputControl_backgroundPosition_large: 'right 40px top ' + (size.large - 2 - 14) / 2 + 'px',
    InputControl_backgroundSize: '14px 14px',
    Button_backgroundColor_themePrimary: backgroundColor_naked,
    Button_backgroundColor_themePrimary_disabled: backgroundColor_naked,
    Button_backgroundColor_themeSecondary: backgroundColor_naked,
    Button_backgroundColor_themeSecondary_disabled: backgroundColor_naked,
    Button_borderColor_themePrimary: borderColor_naked,
    Button_borderColor_themePrimary_disabled: borderColor_naked,
    Button_borderColor_themePrimary_active: ninja11 + ' ' + ninja11 + ' ' + ninja11 + ' ' + color.transparent,
    Button_borderColor_themePrimary_focus: ninja11 + ' ' + ninja11 + ' ' + ninja11 + ' ' + color.transparent,
    Button_borderColor_themePrimary_hover: ninja11 + ' ' + ninja11 + ' ' + ninja11 + ' ' + color.transparent,
    Button_borderColor_themeSecondary: borderColor_naked,
    Button_borderColor_themeSecondary_disabled: borderColor_naked,
    Button_borderColor_themeSecondary_active: ninja11 + ' ' + ninja11 + ' ' + ninja11 + ' ' + color.transparent,
    Button_borderColor_themeSecondary_focus: ninja11 + ' ' + ninja11 + ' ' + ninja11 + ' ' + color.transparent,
    Button_borderColor_themeSecondary_hover: ninja11 + ' ' + ninja11 + ' ' + ninja11 + ' ' + color.transparent,
    Button_color_themePrimary: function primaryDarker(_ref) {
      var sc = _ref.sc;
      return color.primary.getMainShade({
        backgroundColor: sc.colorBehindButton,
        offset: 1
      });
    },
    Button_color_themePrimary_disabled: color_disabled,
    Button_color_themeSecondary: function secondaryDarker(_ref2) {
      var sc = _ref2.sc;
      return color.secondary.getMainShade({
        backgroundColor: sc.colorBehindButton,
        offset: 1
      });
    },
    Button_color_themeSecondary_disabled: color_disabled,
    Button_borderRadius: '0 16px 16px 0',
    Button_boxShadow_themePrimary_focus: 'none',
    Button_boxShadow_themeSecondary_focus: 'none',
    Button_paddingHorizontal_withIconSmall: '12px',
    Button_paddingHorizontal_withIconMedium: '12px',
    Button_paddingHorizontal_withIconLarge: '12px'
  });
};

exports.default = componentTheme;